import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Swal from 'sweetalert2';
import Loading from '../../Components/Loading/LoadingCenterPage';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, Chip, IconButton, Tooltip } from '@mui/material';
import { 
    ShoppingBagIcon, 
    CheckCircleIcon, 
    TrashIcon,
    DocumentTextIcon,
    ClockIcon,
    CurrencyDollarIcon
} from '@heroicons/react/24/outline';

const ReportOrderShirt = () => {

    const [open, setOpen] = React.useState(false);
    const [fullWidth] = React.useState(true);
    const [maxWidth] = React.useState('false');

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const formatMoney = (value) => {
        const data = new Intl.NumberFormat().format(value)
        return data
    }

    const date = (value) => {
        return new Date(value).toLocaleString('th-TH', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        })
    }

    const [dataOrder, setDataOrder] = React.useState(null);

    const getDataOrder = async () => {
        fetch('https://script.google.com/macros/s/AKfycbzKbLbsjasaPeZ_aLfFCIRsjTonDfEwcCfgIeZHS7HRMhGNz0jfnqsWnscVkzEjL4pHYw/exec', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({ action: 'read' }),
        })
            .then(response => response.json())
            .then(res => {
                setDataOrder(res.data || [])
                console.log('Load DataRegistration Success');
            })
            .catch(error => console.error('Error!', error.message));
    };
    React.useEffect(() => {
        if (dataOrder === null) {
            getDataOrder();
        }
    }, [dataOrder]);

    const dataOK = dataOrder?.filter(v => v.status === "yes")
    const dataNonOK = dataOrder?.filter(v => v.status !== "yes")
    const manageData = React.useMemo(() => {
        try {

            const handleCheck = (data) => {

                const form = document.getElementById('remark')
                const formData = new FormData(form);

                if (formData.get("remark") === "") {

                    Swal.fire({
                        title: "ไม่ได้ระบุหมายเหตุ",
                        icon: 'error',
                        confirmButtonText: "ตกลง",
                        allowOutsideClick: () => {
                            const popup = Swal.getPopup()
                            popup.classList.remove('swal2-show')
                            setTimeout(() => {
                                popup.classList.add('animate__animated', 'animate__headShake')
                            })
                            setTimeout(() => {
                                popup.classList.remove('animate__animated', 'animate__headShake')
                            }, 500)
                            return false
                        },
                    })

                    return

                }

                Swal.fire({
                    title: "ยืนยันบันทึก",
                    icon: 'warning',
                    showDenyButton: true,
                    confirmButtonText: "ตกลง",
                    denyButtonText: `ยกเลิก`,
                    allowOutsideClick: () => {
                        const popup = Swal.getPopup()
                        popup.classList.remove('swal2-show')
                        setTimeout(() => {
                            popup.classList.add('animate__animated', 'animate__headShake')
                        })
                        setTimeout(() => {
                            popup.classList.remove('animate__animated', 'animate__headShake')
                        }, 500)
                        return false
                    },
                }).then((result) => {

                    if (result.isConfirmed) {

                        fetch('https://script.google.com/macros/s/AKfycbzKbLbsjasaPeZ_aLfFCIRsjTonDfEwcCfgIeZHS7HRMhGNz0jfnqsWnscVkzEjL4pHYw/exec', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                            body: new URLSearchParams({
                                status: "yes",
                                remark: formData.get("remark"),
                                action: "update",
                                group: data
                            })
                        })
                            .then(response => response.json())
                            .then(() => {
                                Swal.fire({
                                    title: 'บันทึกข้อมูลสำเร็จ!!',
                                    icon: 'success',
                                    confirmButtonText: 'ตกลง',
                                }).then((result) => {
                                    if (result.isConfirmed) {

                                        getDataOrder()

                                    }
                                });
                            })
                            .catch(error => console.error('Error!', error.message));

                    }

                });

            }

            const handleDelete = (data) => {

                Swal.fire({
                    title: "ยืนยันลบ",
                    icon: 'warning',
                    showDenyButton: true,
                    confirmButtonText: "ตกลง",
                    denyButtonText: `ยกเลิก`,
                    allowOutsideClick: () => {
                        const popup = Swal.getPopup()
                        popup.classList.remove('swal2-show')
                        setTimeout(() => {
                            popup.classList.add('animate__animated', 'animate__headShake')
                        })
                        setTimeout(() => {
                            popup.classList.remove('animate__animated', 'animate__headShake')
                        }, 500)
                        return false
                    },
                }).then((result) => {

                    if (result.isConfirmed) {

                        fetch('https://script.google.com/macros/s/AKfycbzKbLbsjasaPeZ_aLfFCIRsjTonDfEwcCfgIeZHS7HRMhGNz0jfnqsWnscVkzEjL4pHYw/exec', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                            body: new URLSearchParams({
                                action: "delete",
                                group: data
                            })
                        })
                            .then(response => response.json())
                            .then(() => {
                                Swal.fire({
                                    title: 'ลบสำเร็จ!!',
                                    icon: 'success',
                                    confirmButtonText: 'ตกลง',
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        getDataOrder();
                                    }
                                });
                            })
                            .catch(error => console.error('Error!', error.message));

                    }

                });

            }

            const object = {}
            dataNonOK?.forEach(trans => {
                const { group } = trans
                if (!object[group]) {
                    object[group] = { transaction: [] }
                }
                object[group].transaction?.push(trans)
            })

            const results = Object.entries(object).map(([key, { transaction }]) => {

                const dataGroup = object[key]?.transaction[0]
                const sumData = object[key]?.transaction?.reduce((acc, item) => {
                    const totalCost = Number(item.total) * Number(item.amount);
                    return acc + totalCost;
                }, 0);

                return (
                    <TableRow key={key} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell align="center">
                            <div className="flex items-center justify-center gap-2">
                                <ClockIcon className="h-4 w-4 text-gray-400" />
                                <span className="text-sm font-semibold text-gray-700">{date(dataGroup?.timestamp)}</span>
                            </div>
                        </TableCell>
                        <TableCell align="left">
                            <Chip 
                                label={dataGroup?.hname} 
                                sx={{ bgcolor: '#E0E7FF', color: '#4338CA', fontWeight: 700, fontSize: 12 }} 
                            />
                        </TableCell>
                        <TableCell align="left">
                            <div className="space-y-2 py-2">
                                {transaction?.map((a, b) => (
                                    <div key={b} className="flex items-start gap-2 p-2 bg-gray-50 rounded-lg">
                                        <span className="flex-shrink-0 w-6 h-6 bg-indigo-100 text-indigo-700 rounded-full flex items-center justify-center text-xs font-bold">
                                            {b + 1}
                                        </span>
                                        <div className="flex-1">
                                            <p className="text-sm">
                                                <span className="font-bold text-purple-600">{a.name}</span>
                                                <span className="text-gray-600"> ไซส์ {a.size}</span>
                                            </p>
                                            <p className="text-xs text-gray-500 mt-1">
                                                จำนวน <span className="font-bold text-gray-700">{a.amount}</span> ชิ้น × 
                                                <span className="font-bold text-gray-700"> {a.total}</span> บาท = 
                                                <span className="font-bold text-indigo-600"> {formatMoney(Number(a.total) * Number(a.amount))}</span> บาท
                                            </p>
                                        </div>
                                    </div>
                                ))}
                                <div className="mt-3 p-3 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl border border-green-200">
                                    <p className="text-sm font-bold text-green-700 flex items-center gap-2">
                                        <CurrencyDollarIcon className="h-5 w-5" />
                                        รวมยอดเงินที่ต้องโอน: 
                                        <span className="text-lg text-green-900">{formatMoney(sumData || 0)}</span> บาท
                                    </p>
                                </div>
                            </div>
                        </TableCell>
                        <TableCell align="center">
                            <Tooltip title="ดูสลิปโอนเงิน">
                                <IconButton 
                                    component={Link} 
                                    to={dataGroup?.imageUrl} 
                                    target="_blank"
                                    sx={{ bgcolor: '#EEF2FF', '&:hover': { bgcolor: '#E0E7FF' } }}
                                >
                                    <DocumentTextIcon className="h-5 w-5 text-indigo-600" />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                        <TableCell align="center">
                            <Box
                                id='remark'
                                component="form"
                                sx={{ display: 'flex', justifyContent: 'center' }}
                                noValidate
                                autoComplete="off"
                            >
                                <TextField 
                                    required 
                                    name='remark' 
                                    type='text' 
                                    placeholder="เพิ่มหมายเหตุ..."
                                    variant="outlined"
                                    size="small"
                                    sx={{ width: '200px' }}
                                />
                            </Box>
                        </TableCell>
                        <TableCell align="center">
                            <div className="flex items-center justify-center gap-2">
                                <Tooltip title="ยืนยันคำสั่งซื้อ">
                                    <IconButton 
                                        onClick={() => handleCheck(key)}
                                        sx={{ bgcolor: '#ECFDF5', '&:hover': { bgcolor: '#D1FAE5' } }}
                                    >
                                        <CheckCircleIcon className="h-5 w-5 text-green-600" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="ลบคำสั่งซื้อ">
                                    <IconButton 
                                        onClick={() => handleDelete(key)}
                                        sx={{ bgcolor: '#FEF2F2', '&:hover': { bgcolor: '#FEE2E2' } }}
                                    >
                                        <TrashIcon className="h-5 w-5 text-red-600" />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </TableCell>
                    </TableRow>
                )

            })

            return results

        } catch (error) {
            return null
        }
    }, [dataNonOK])

    const manageDataOK = React.useMemo(() => {
        try {

            const object = {}
            dataOK?.forEach(trans => {
                const { group } = trans
                if (!object[group]) {
                    object[group] = { transaction: [] }
                }
                object[group].transaction?.push(trans)
            })

            const results = Object.entries(object).map(([key, { transaction }]) => {

                const dataGroup = object[key]?.transaction[0]
                const sumData = object[key]?.transaction?.reduce((acc, item) => {
                    const totalCost = Number(item.total) * Number(item.amount);
                    return acc + totalCost;
                }, 0);

                return (
                    <TableRow key={key} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell align="center">
                            <Chip 
                                label={date(dataGroup?.timestamp)} 
                                size="small" 
                                sx={{ bgcolor: '#F0FDF4', color: '#166534', fontWeight: 700, fontSize: 11 }} 
                            />
                        </TableCell>
                        <TableCell align="left">
                            <Chip 
                                label={dataGroup?.hname} 
                                sx={{ bgcolor: '#DBEAFE', color: '#1E40AF', fontWeight: 700, fontSize: 12 }} 
                            />
                        </TableCell>
                        <TableCell align="left">
                            <div className="space-y-2 py-2">
                                {transaction?.map((a, b) => (
                                    <div key={b} className="flex items-start gap-2 p-2 bg-gray-50 rounded-lg">
                                        <span className="flex-shrink-0 w-6 h-6 bg-green-100 text-green-700 rounded-full flex items-center justify-center text-xs font-bold">
                                            {b + 1}
                                        </span>
                                        <div className="flex-1">
                                            <p className="text-sm">
                                                <span className="font-bold text-gray-900">{a.name}</span>
                                                <span className="text-gray-600"> ไซส์ {a.size}</span>
                                            </p>
                                            <p className="text-xs text-gray-500 mt-1">
                                                จำนวน <span className="font-bold">{a.amount}</span> ชิ้น × 
                                                <span className="font-bold"> {a.total}</span> บาท = 
                                                <span className="font-bold text-green-600"> {formatMoney(Number(a.total) * Number(a.amount))}</span> บาท
                                            </p>
                                        </div>
                                    </div>
                                ))}
                                <div className="mt-2 p-2 bg-green-50 rounded-lg border border-green-200">
                                    <p className="text-xs font-bold text-green-700">
                                        รวมยอด: <span className="text-sm">{formatMoney(sumData || 0)}</span> บาท
                                    </p>
                                </div>
                            </div>
                        </TableCell>
                        <TableCell align="center">
                            <Tooltip title="ดูสลิปโอนเงิน">
                                <IconButton 
                                    component={Link} 
                                    to={dataGroup?.imageUrl} 
                                    target="_blank"
                                    size="small"
                                    sx={{ bgcolor: '#EEF2FF', '&:hover': { bgcolor: '#E0E7FF' } }}
                                >
                                    <DocumentTextIcon className="h-4 w-4 text-indigo-600" />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                        <TableCell align="center">
                            <Chip 
                                label={dataGroup?.remark} 
                                size="small" 
                                sx={{ bgcolor: '#FEF3C7', color: '#92400E', fontWeight: 600, fontSize: 11 }} 
                            />
                        </TableCell>
                    </TableRow>
                )

            })

            return results

        } catch (error) {
            return null
        }
    }, [dataOK])

    return (
        <>
            {dataOrder !== null ? (
                <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 md:p-8">
                    <div className="max-w-[1800px] mx-auto">
                        
                        {/* Header Section */}
                        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-6 md:p-8 mb-6">
                            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                                <div className="flex items-center gap-4">
                                    <div className="p-3 bg-gradient-to-br from-purple-500 to-purple-600 rounded-2xl shadow-lg">
                                        <ShoppingBagIcon className="h-8 w-8 text-white" />
                                    </div>
                                    <div>
                                        <h1 className="text-3xl font-black text-gray-900 tracking-tight">รายงานการสั่งซื้อเสื้อพนักงาน</h1>
                                        <p className="text-sm text-gray-500 mt-1">ระบบจัดการคำสั่งซื้อและติดตามสถานะ</p>
                                    </div>
                                </div>
                                <Button 
                                    onClick={handleClickOpen} 
                                    variant="contained" 
                                    startIcon={<CheckCircleIcon style={{ width: 20 }} />}
                                    sx={{ 
                                        borderRadius: 3, 
                                        px: 4, 
                                        py: 1.5, 
                                        bgcolor: '#10B981', 
                                        textTransform: 'none', 
                                        fontWeight: 700,
                                        boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
                                        '&:hover': { bgcolor: '#059669' }
                                    }}
                                >
                                    รายการสำเร็จแล้ว
                                </Button>
                            </div>

                            {/* Stats Cards */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
                                <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-4 border border-blue-200">
                                    <div className="flex items-center gap-3">
                                        <ClockIcon className="h-6 w-6 text-blue-600" />
                                        <div>
                                            <p className="text-xs text-blue-600 font-semibold uppercase">รอดำเนินการ</p>
                                            <p className="text-2xl font-black text-blue-900">{dataNonOK?.length || 0}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-4 border border-green-200">
                                    <div className="flex items-center gap-3">
                                        <CheckCircleIcon className="h-6 w-6 text-green-600" />
                                        <div>
                                            <p className="text-xs text-green-600 font-semibold uppercase">สำเร็จแล้ว</p>
                                            <p className="text-2xl font-black text-green-900">{dataOK?.length || 0}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-4 border border-purple-200">
                                    <div className="flex items-center gap-3">
                                        <CurrencyDollarIcon className="h-6 w-6 text-purple-600" />
                                        <div>
                                            <p className="text-xs text-purple-600 font-semibold uppercase">คำสั่งซื้อทั้งหมด</p>
                                            <p className="text-2xl font-black text-purple-900">{dataOrder?.length || 0}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Table Section */}
                        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">
                            <TableContainer sx={{ maxHeight: 750 }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, fontSize: 13, py: 2.5, color: '#475569', minWidth: 150 }}>วันที่สั่งซื้อ</TableCell>
                                            <TableCell align="center" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, fontSize: 13, py: 2.5, color: '#475569', minWidth: 200 }}>สถานที่จัดส่ง</TableCell>
                                            <TableCell align="left" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, fontSize: 13, py: 2.5, color: '#475569', minWidth: 400 }}>รายการสินค้า</TableCell>
                                            <TableCell align="center" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, fontSize: 13, py: 2.5, color: '#475569' }}>สลิปโอนเงิน</TableCell>
                                            <TableCell align="center" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, fontSize: 13, py: 2.5, color: '#475569', minWidth: 200 }}>หมายเหตุ</TableCell>
                                            <TableCell align="center" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, fontSize: 13, py: 2.5, color: '#475569' }}>จัดการ</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {manageData}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>

                        {/* Dialog for Completed Orders */}
                        <Dialog
                            fullWidth
                            maxWidth="xl"
                            open={open}
                            onClose={handleClose}
                            disableEnforceFocus
                            PaperProps={{ sx: { borderRadius: 5, p: 2 } }}
                        >
                            <DialogTitle sx={{ fontWeight: 900, fontSize: '1.5rem', pb: 1 }}>
                                <div className="flex items-center gap-3">
                                    <div className="p-2 bg-green-100 rounded-xl">
                                        <CheckCircleIcon className="h-6 w-6 text-green-600" />
                                    </div>
                                    <span>รายการสั่งซื้อที่สำเร็จแล้ว</span>
                                </div>
                            </DialogTitle>
                            <DialogContent>
                                <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 3, maxHeight: 550 }}>
                                    <Table stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, py: 2 }}>วันที่สั่งซื้อ</TableCell>
                                                <TableCell align="center" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, py: 2 }}>สถานที่จัดส่ง</TableCell>
                                                <TableCell align="left" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, py: 2 }}>รายการสินค้า</TableCell>
                                                <TableCell align="center" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, py: 2 }}>สลิปโอนเงิน</TableCell>
                                                <TableCell align="center" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, py: 2 }}>หมายเหตุ</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {manageDataOK}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </DialogContent>
                            <DialogActions sx={{ p: 3 }}>
                                <Button 
                                    onClick={handleClose} 
                                    sx={{ 
                                        color: '#64748B', 
                                        fontWeight: 700,
                                        '&:hover': { bgcolor: '#F1F5F9' }
                                    }}
                                >
                                    ปิดหน้าต่าง
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </div>
            ) : (
                <Loading />
            )}
        </>
    )
}

export default ReportOrderShirt
